var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircularDotLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".spinner_Wezc{transform-origin:center;animation:spinner_Oiah .75s step-end infinite}@keyframes spinner_Oiah{8.3%{transform:rotate(30deg)}16.6%{transform:rotate(60deg)}25%{transform:rotate(90deg)}33.3%{transform:rotate(120deg)}41.6%{transform:rotate(150deg)}50%{transform:rotate(180deg)}58.3%{transform:rotate(210deg)}66.6%{transform:rotate(240deg)}75%{transform:rotate(270deg)}83.3%{transform:rotate(300deg)}91.6%{transform:rotate(330deg)}100%{transform:rotate(360deg)}}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "spinner_Wezc"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2.5,
    r: 1.5,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 3.77,
    r: 1.5,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.23,
    cy: 7.25,
    r: 1.5,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 12,
    r: 1.5,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.23,
    cy: 16.75,
    r: 1.5,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 20.23,
    r: 1.5,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21.5,
    r: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularDotLoader);
export default __webpack_public_path__ + "static/media/circular_dot_loader.98bb64fc57f579f6a3a0c8ac451ce5b0.svg";
export { ForwardRef as ReactComponent };